"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensStackImpressionTrack = exports.TileViewImpressionTrack = exports.LensTileImpressionTrack = exports.LensExplorerImpressionTrack = exports.LensImpressionTrack = exports.LensCarouselImpressionTrack = exports.LensImpressionTrack_IndependentLensImpressionTrigger = exports.LensImpressionTrack_ClientTrackLoggingStrategy = exports.LensImpressionTrack_TrackType = exports.LensImpressionTrack_LensSource = exports.LensImpressionTrack_UnlockType = exports.LensCarouselImpressionTrack_CarouselExitEvent = void 0;
const unlockable_attachment_impression_1 = require("./unlockable_attachment_impression");
const snap_creation_info_1 = require("./snap_creation_info");
const device_info_1 = require("./device/device_info");
const lens_performance_metrics_1 = require("./lens_performance_metrics");
const ad_flag_data_1 = require("./ad_flag_data");
const lens_product_impression_track_1 = require("./lens_product_impression_track");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../../google/protobuf/wrappers");
/** Describes the method in which the user exited the carousel */
var LensCarouselImpressionTrack_CarouselExitEvent;
(function (LensCarouselImpressionTrack_CarouselExitEvent) {
    LensCarouselImpressionTrack_CarouselExitEvent[LensCarouselImpressionTrack_CarouselExitEvent["UNKNOWN_EXIT_EVENT"] = 0] = "UNKNOWN_EXIT_EVENT";
    LensCarouselImpressionTrack_CarouselExitEvent[LensCarouselImpressionTrack_CarouselExitEvent["SWIPE_LEFT"] = 1] = "SWIPE_LEFT";
    LensCarouselImpressionTrack_CarouselExitEvent[LensCarouselImpressionTrack_CarouselExitEvent["SWIPE_RIGHT"] = 2] = "SWIPE_RIGHT";
    LensCarouselImpressionTrack_CarouselExitEvent[LensCarouselImpressionTrack_CarouselExitEvent["SWIPE_UP"] = 3] = "SWIPE_UP";
    LensCarouselImpressionTrack_CarouselExitEvent[LensCarouselImpressionTrack_CarouselExitEvent["SWIPE_DOWN"] = 4] = "SWIPE_DOWN";
    LensCarouselImpressionTrack_CarouselExitEvent[LensCarouselImpressionTrack_CarouselExitEvent["EXIT_CAROUSEL"] = 5] = "EXIT_CAROUSEL";
    LensCarouselImpressionTrack_CarouselExitEvent[LensCarouselImpressionTrack_CarouselExitEvent["CAPTURE_SNAP"] = 6] = "CAPTURE_SNAP";
    LensCarouselImpressionTrack_CarouselExitEvent[LensCarouselImpressionTrack_CarouselExitEvent["BACKGROUND_APP"] = 7] = "BACKGROUND_APP";
    LensCarouselImpressionTrack_CarouselExitEvent[LensCarouselImpressionTrack_CarouselExitEvent["OPEN_SEARCH"] = 8] = "OPEN_SEARCH";
    LensCarouselImpressionTrack_CarouselExitEvent[LensCarouselImpressionTrack_CarouselExitEvent["OPEN_PROFILE"] = 9] = "OPEN_PROFILE";
    LensCarouselImpressionTrack_CarouselExitEvent[LensCarouselImpressionTrack_CarouselExitEvent["ADD_FRIENDS"] = 10] = "ADD_FRIENDS";
    LensCarouselImpressionTrack_CarouselExitEvent[LensCarouselImpressionTrack_CarouselExitEvent["CLICK_CTA"] = 11] = "CLICK_CTA";
    LensCarouselImpressionTrack_CarouselExitEvent[LensCarouselImpressionTrack_CarouselExitEvent["OPEN_SUB_CAROUSEL"] = 12] = "OPEN_SUB_CAROUSEL";
    LensCarouselImpressionTrack_CarouselExitEvent[LensCarouselImpressionTrack_CarouselExitEvent["CLOSE_SUB_CAROUSEL"] = 13] = "CLOSE_SUB_CAROUSEL";
    LensCarouselImpressionTrack_CarouselExitEvent[LensCarouselImpressionTrack_CarouselExitEvent["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LensCarouselImpressionTrack_CarouselExitEvent = exports.LensCarouselImpressionTrack_CarouselExitEvent || (exports.LensCarouselImpressionTrack_CarouselExitEvent = {}));
var LensImpressionTrack_UnlockType;
(function (LensImpressionTrack_UnlockType) {
    LensImpressionTrack_UnlockType[LensImpressionTrack_UnlockType["UNKNOWN_UNLOCK_TYPE"] = 0] = "UNKNOWN_UNLOCK_TYPE";
    LensImpressionTrack_UnlockType[LensImpressionTrack_UnlockType["NO_UNLOCK"] = 1] = "NO_UNLOCK";
    LensImpressionTrack_UnlockType[LensImpressionTrack_UnlockType["SOCIAL_UNLOCK"] = 2] = "SOCIAL_UNLOCK";
    LensImpressionTrack_UnlockType[LensImpressionTrack_UnlockType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LensImpressionTrack_UnlockType = exports.LensImpressionTrack_UnlockType || (exports.LensImpressionTrack_UnlockType = {}));
/** Describes a "feature" source of reported lens. */
var LensImpressionTrack_LensSource;
(function (LensImpressionTrack_LensSource) {
    LensImpressionTrack_LensSource[LensImpressionTrack_LensSource["UNKNOWN"] = 0] = "UNKNOWN";
    LensImpressionTrack_LensSource[LensImpressionTrack_LensSource["LIVE_CAMERA"] = 1] = "LIVE_CAMERA";
    LensImpressionTrack_LensSource[LensImpressionTrack_LensSource["POST_CAPTURE"] = 2] = "POST_CAPTURE";
    LensImpressionTrack_LensSource[LensImpressionTrack_LensSource["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LensImpressionTrack_LensSource = exports.LensImpressionTrack_LensSource || (exports.LensImpressionTrack_LensSource = {}));
/** Specifies the type of track this particular instance of impression track represents. */
var LensImpressionTrack_TrackType;
(function (LensImpressionTrack_TrackType) {
    LensImpressionTrack_TrackType[LensImpressionTrack_TrackType["UNKNOWN_TRACK_TYPE"] = 0] = "UNKNOWN_TRACK_TYPE";
    LensImpressionTrack_TrackType[LensImpressionTrack_TrackType["CAROUSEL_SESSION"] = 1] = "CAROUSEL_SESSION";
    LensImpressionTrack_TrackType[LensImpressionTrack_TrackType["INDEPENDENT_LENS_IMPRESSION"] = 2] = "INDEPENDENT_LENS_IMPRESSION";
    LensImpressionTrack_TrackType[LensImpressionTrack_TrackType["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LensImpressionTrack_TrackType = exports.LensImpressionTrack_TrackType || (exports.LensImpressionTrack_TrackType = {}));
/** Describes how client logs the lens impression track */
var LensImpressionTrack_ClientTrackLoggingStrategy;
(function (LensImpressionTrack_ClientTrackLoggingStrategy) {
    LensImpressionTrack_ClientTrackLoggingStrategy[LensImpressionTrack_ClientTrackLoggingStrategy["UNKNOWN_CLIENT_TRACK_LOGGING_STRATEGY"] = 0] = "UNKNOWN_CLIENT_TRACK_LOGGING_STRATEGY";
    LensImpressionTrack_ClientTrackLoggingStrategy[LensImpressionTrack_ClientTrackLoggingStrategy["WITH_CAROUSEL_SESSION"] = 1] = "WITH_CAROUSEL_SESSION";
    LensImpressionTrack_ClientTrackLoggingStrategy[LensImpressionTrack_ClientTrackLoggingStrategy["INDEPENDENT_ON_SESSION_END"] = 2] = "INDEPENDENT_ON_SESSION_END";
    LensImpressionTrack_ClientTrackLoggingStrategy[LensImpressionTrack_ClientTrackLoggingStrategy["INDEPENDENT_ON_LENS_EXIT"] = 3] = "INDEPENDENT_ON_LENS_EXIT";
    LensImpressionTrack_ClientTrackLoggingStrategy[LensImpressionTrack_ClientTrackLoggingStrategy["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LensImpressionTrack_ClientTrackLoggingStrategy = exports.LensImpressionTrack_ClientTrackLoggingStrategy || (exports.LensImpressionTrack_ClientTrackLoggingStrategy = {}));
/** Specifies the event that triggers the current lens impression */
var LensImpressionTrack_IndependentLensImpressionTrigger;
(function (LensImpressionTrack_IndependentLensImpressionTrigger) {
    LensImpressionTrack_IndependentLensImpressionTrigger[LensImpressionTrack_IndependentLensImpressionTrigger["UNKNOWN_TYPE"] = 0] = "UNKNOWN_TYPE";
    LensImpressionTrack_IndependentLensImpressionTrigger[LensImpressionTrack_IndependentLensImpressionTrigger["LENS_EXIT"] = 1] = "LENS_EXIT";
    LensImpressionTrack_IndependentLensImpressionTrigger[LensImpressionTrack_IndependentLensImpressionTrigger["SNAP_CAPTURE_SESSION_ENDED"] = 2] = "SNAP_CAPTURE_SESSION_ENDED";
    LensImpressionTrack_IndependentLensImpressionTrigger[LensImpressionTrack_IndependentLensImpressionTrigger["ATTACHMENT_CLOSE"] = 3] = "ATTACHMENT_CLOSE";
    LensImpressionTrack_IndependentLensImpressionTrigger[LensImpressionTrack_IndependentLensImpressionTrigger["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LensImpressionTrack_IndependentLensImpressionTrigger = exports.LensImpressionTrack_IndependentLensImpressionTrigger || (exports.LensImpressionTrack_IndependentLensImpressionTrigger = {}));
function createBaseLensCarouselImpressionTrack() {
    return {
        snapCreationInfo: undefined,
        lensSessionId: undefined,
        carouselSize: undefined,
        lensImpressions: [],
        deviceInfo: undefined,
        carouselExitEvent: 0,
        cameraType: 0,
        lastInteractedLensId: undefined,
    };
}
exports.LensCarouselImpressionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.snapCreationInfo !== undefined) {
            snap_creation_info_1.SnapCreationInfo.encode(message.snapCreationInfo, writer.uint32(10).fork()).ldelim();
        }
        if (message.lensSessionId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.lensSessionId }, writer.uint32(18).fork()).ldelim();
        }
        if (message.carouselSize !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.carouselSize }, writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.lensImpressions) {
            exports.LensImpressionTrack.encode(v, writer.uint32(34).fork()).ldelim();
        }
        if (message.deviceInfo !== undefined) {
            device_info_1.DeviceInfo.encode(message.deviceInfo, writer.uint32(42).fork()).ldelim();
        }
        if (message.carouselExitEvent !== 0) {
            writer.uint32(48).int32(message.carouselExitEvent);
        }
        if (message.cameraType !== 0) {
            writer.uint32(56).int32(message.cameraType);
        }
        if (message.lastInteractedLensId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.lastInteractedLensId }, writer.uint32(66).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLensCarouselImpressionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.snapCreationInfo = snap_creation_info_1.SnapCreationInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.lensSessionId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.carouselSize = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.lensImpressions.push(exports.LensImpressionTrack.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.deviceInfo = device_info_1.DeviceInfo.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.carouselExitEvent = reader.int32();
                    break;
                case 7:
                    message.cameraType = reader.int32();
                    break;
                case 8:
                    message.lastInteractedLensId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLensCarouselImpressionTrack();
        message.snapCreationInfo =
            object.snapCreationInfo !== undefined && object.snapCreationInfo !== null
                ? snap_creation_info_1.SnapCreationInfo.fromPartial(object.snapCreationInfo)
                : undefined;
        message.lensSessionId = object.lensSessionId ?? undefined;
        message.carouselSize = object.carouselSize ?? undefined;
        message.lensImpressions =
            object.lensImpressions?.map((e) => exports.LensImpressionTrack.fromPartial(e)) ||
                [];
        message.deviceInfo =
            object.deviceInfo !== undefined && object.deviceInfo !== null
                ? device_info_1.DeviceInfo.fromPartial(object.deviceInfo)
                : undefined;
        message.carouselExitEvent = object.carouselExitEvent ?? 0;
        message.cameraType = object.cameraType ?? 0;
        message.lastInteractedLensId = object.lastInteractedLensId ?? undefined;
        return message;
    },
};
function createBaseLensImpressionTrack() {
    return {
        lensId: undefined,
        totalSwipedViewMillis: undefined,
        lensOptionId: undefined,
        swipedOverCount: undefined,
        withSnapSend: undefined,
        withStoryPost: undefined,
        withMemoriesSave: undefined,
        withSelfieCamera: undefined,
        withWorldCamera: undefined,
        isAudioOn: undefined,
        lensIndexPos: undefined,
        encryptedAdTrackData: new Uint8Array(),
        encryptedSponsoredUnlockableTargetingInfoData: new Uint8Array(),
        rankingId: new Uint8Array(),
        rankingData: new Uint8Array(),
        attachmentImpression: undefined,
        encGeoData: new Uint8Array(),
        withAttachmentOpen: undefined,
        attachmentType: 0,
        snapSendRecipientCount: undefined,
        snapSendCount: undefined,
        storyPostCount: undefined,
        memoriesSaveCount: undefined,
        captureTimeMillis: undefined,
        postCaptureTimeMillis: undefined,
        maxSwipeTimeMillis: undefined,
        maxContinuousTimeMillis: undefined,
        totalTimeMillis: undefined,
        reactionTimestamp: undefined,
        shareTimestamp: undefined,
        swipeUpTimestamp: undefined,
        saveTimestamp: undefined,
        screenshotTimestamp: undefined,
        unlockType: 0,
        lensCreativeId: new Uint8Array(),
        firstFaceRenderTimestamp: undefined,
        firstTriggerTimestamp: undefined,
        lensPerformanceMetrics: undefined,
        adFlagData: undefined,
        lensProductImpressionCollectionTrack: undefined,
        lensSource: 0,
        stackedImpressions: [],
        isCachedBeforeSession: undefined,
        isCachedAfterSession: undefined,
        noFillServeItemId: new Uint8Array(),
        snapTakenCount: undefined,
        infoClickedCount: undefined,
        withMediaPlayPrecapture: undefined,
        withMediaPlayPostcapture: undefined,
        isRendered: undefined,
        mixerRequestId: new Uint8Array(),
        lensNamespace: undefined,
        sponsoredType: 0,
        lensSessionId: undefined,
        deviceInfo: undefined,
        cameraType: 0,
        isTrackLoggedIndependently: undefined,
        trackType: 0,
        clientTrackLoggingStrategy: 0,
        carouselExitEvent: 0,
        independentLensImpressionTrigger: 0,
        maxScreenPortionRendered: undefined,
    };
}
exports.LensImpressionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.lensId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.lensId }, writer.uint32(10).fork()).ldelim();
        }
        if (message.totalSwipedViewMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.totalSwipedViewMillis }, writer.uint32(18).fork()).ldelim();
        }
        if (message.lensOptionId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.lensOptionId }, writer.uint32(26).fork()).ldelim();
        }
        if (message.swipedOverCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.swipedOverCount }, writer.uint32(34).fork()).ldelim();
        }
        if (message.withSnapSend !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.withSnapSend }, writer.uint32(42).fork()).ldelim();
        }
        if (message.withStoryPost !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.withStoryPost }, writer.uint32(50).fork()).ldelim();
        }
        if (message.withMemoriesSave !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.withMemoriesSave }, writer.uint32(58).fork()).ldelim();
        }
        if (message.withSelfieCamera !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.withSelfieCamera }, writer.uint32(66).fork()).ldelim();
        }
        if (message.withWorldCamera !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.withWorldCamera }, writer.uint32(74).fork()).ldelim();
        }
        if (message.isAudioOn !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isAudioOn }, writer.uint32(82).fork()).ldelim();
        }
        if (message.lensIndexPos !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.lensIndexPos }, writer.uint32(90).fork()).ldelim();
        }
        if (message.encryptedAdTrackData.length !== 0) {
            writer.uint32(98).bytes(message.encryptedAdTrackData);
        }
        if (message.encryptedSponsoredUnlockableTargetingInfoData.length !== 0) {
            writer
                .uint32(106)
                .bytes(message.encryptedSponsoredUnlockableTargetingInfoData);
        }
        if (message.rankingId.length !== 0) {
            writer.uint32(114).bytes(message.rankingId);
        }
        if (message.rankingData.length !== 0) {
            writer.uint32(122).bytes(message.rankingData);
        }
        if (message.attachmentImpression !== undefined) {
            unlockable_attachment_impression_1.UnlockableAttachmentImpression.encode(message.attachmentImpression, writer.uint32(130).fork()).ldelim();
        }
        if (message.encGeoData.length !== 0) {
            writer.uint32(138).bytes(message.encGeoData);
        }
        if (message.withAttachmentOpen !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.withAttachmentOpen }, writer.uint32(146).fork()).ldelim();
        }
        if (message.attachmentType !== 0) {
            writer.uint32(152).int32(message.attachmentType);
        }
        if (message.snapSendRecipientCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.snapSendRecipientCount }, writer.uint32(162).fork()).ldelim();
        }
        if (message.snapSendCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.snapSendCount }, writer.uint32(170).fork()).ldelim();
        }
        if (message.storyPostCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.storyPostCount }, writer.uint32(178).fork()).ldelim();
        }
        if (message.memoriesSaveCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.memoriesSaveCount }, writer.uint32(186).fork()).ldelim();
        }
        if (message.captureTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.captureTimeMillis }, writer.uint32(194).fork()).ldelim();
        }
        if (message.postCaptureTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.postCaptureTimeMillis }, writer.uint32(202).fork()).ldelim();
        }
        if (message.maxSwipeTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.maxSwipeTimeMillis }, writer.uint32(210).fork()).ldelim();
        }
        if (message.maxContinuousTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.maxContinuousTimeMillis }, writer.uint32(218).fork()).ldelim();
        }
        if (message.totalTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.totalTimeMillis }, writer.uint32(226).fork()).ldelim();
        }
        if (message.reactionTimestamp !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.reactionTimestamp }, writer.uint32(234).fork()).ldelim();
        }
        if (message.shareTimestamp !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.shareTimestamp }, writer.uint32(242).fork()).ldelim();
        }
        if (message.swipeUpTimestamp !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.swipeUpTimestamp }, writer.uint32(250).fork()).ldelim();
        }
        if (message.saveTimestamp !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.saveTimestamp }, writer.uint32(258).fork()).ldelim();
        }
        if (message.screenshotTimestamp !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.screenshotTimestamp }, writer.uint32(266).fork()).ldelim();
        }
        if (message.unlockType !== 0) {
            writer.uint32(272).int32(message.unlockType);
        }
        if (message.lensCreativeId.length !== 0) {
            writer.uint32(282).bytes(message.lensCreativeId);
        }
        if (message.firstFaceRenderTimestamp !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.firstFaceRenderTimestamp }, writer.uint32(290).fork()).ldelim();
        }
        if (message.firstTriggerTimestamp !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.firstTriggerTimestamp }, writer.uint32(298).fork()).ldelim();
        }
        if (message.lensPerformanceMetrics !== undefined) {
            lens_performance_metrics_1.LensPerformanceMetrics.encode(message.lensPerformanceMetrics, writer.uint32(306).fork()).ldelim();
        }
        if (message.adFlagData !== undefined) {
            ad_flag_data_1.AdFlagData.encode(message.adFlagData, writer.uint32(314).fork()).ldelim();
        }
        if (message.lensProductImpressionCollectionTrack !== undefined) {
            lens_product_impression_track_1.LensProductImpressionCollectionTrack.encode(message.lensProductImpressionCollectionTrack, writer.uint32(322).fork()).ldelim();
        }
        if (message.lensSource !== 0) {
            writer.uint32(328).int32(message.lensSource);
        }
        for (const v of message.stackedImpressions) {
            exports.LensStackImpressionTrack.encode(v, writer.uint32(338).fork()).ldelim();
        }
        if (message.isCachedBeforeSession !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isCachedBeforeSession }, writer.uint32(346).fork()).ldelim();
        }
        if (message.isCachedAfterSession !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isCachedAfterSession }, writer.uint32(354).fork()).ldelim();
        }
        if (message.noFillServeItemId.length !== 0) {
            writer.uint32(362).bytes(message.noFillServeItemId);
        }
        if (message.snapTakenCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.snapTakenCount }, writer.uint32(370).fork()).ldelim();
        }
        if (message.infoClickedCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.infoClickedCount }, writer.uint32(378).fork()).ldelim();
        }
        if (message.withMediaPlayPrecapture !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.withMediaPlayPrecapture }, writer.uint32(386).fork()).ldelim();
        }
        if (message.withMediaPlayPostcapture !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.withMediaPlayPostcapture }, writer.uint32(394).fork()).ldelim();
        }
        if (message.isRendered !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isRendered }, writer.uint32(402).fork()).ldelim();
        }
        if (message.mixerRequestId.length !== 0) {
            writer.uint32(410).bytes(message.mixerRequestId);
        }
        if (message.lensNamespace !== undefined) {
            wrappers_1.StringValue.encode({ value: message.lensNamespace }, writer.uint32(418).fork()).ldelim();
        }
        if (message.sponsoredType !== 0) {
            writer.uint32(424).int32(message.sponsoredType);
        }
        if (message.lensSessionId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.lensSessionId }, writer.uint32(434).fork()).ldelim();
        }
        if (message.deviceInfo !== undefined) {
            device_info_1.DeviceInfo.encode(message.deviceInfo, writer.uint32(442).fork()).ldelim();
        }
        if (message.cameraType !== 0) {
            writer.uint32(448).int32(message.cameraType);
        }
        if (message.isTrackLoggedIndependently !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.isTrackLoggedIndependently }, writer.uint32(458).fork()).ldelim();
        }
        if (message.trackType !== 0) {
            writer.uint32(464).int32(message.trackType);
        }
        if (message.clientTrackLoggingStrategy !== 0) {
            writer.uint32(472).int32(message.clientTrackLoggingStrategy);
        }
        if (message.carouselExitEvent !== 0) {
            writer.uint32(480).int32(message.carouselExitEvent);
        }
        if (message.independentLensImpressionTrigger !== 0) {
            writer.uint32(488).int32(message.independentLensImpressionTrigger);
        }
        if (message.maxScreenPortionRendered !== undefined) {
            wrappers_1.FloatValue.encode({ value: message.maxScreenPortionRendered }, writer.uint32(498).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLensImpressionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.lensId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.totalSwipedViewMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.lensOptionId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.swipedOverCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.withSnapSend = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.withStoryPost = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 7:
                    message.withMemoriesSave = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 8:
                    message.withSelfieCamera = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 9:
                    message.withWorldCamera = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 10:
                    message.isAudioOn = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 11:
                    message.lensIndexPos = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 12:
                    message.encryptedAdTrackData = reader.bytes();
                    break;
                case 13:
                    message.encryptedSponsoredUnlockableTargetingInfoData =
                        reader.bytes();
                    break;
                case 14:
                    message.rankingId = reader.bytes();
                    break;
                case 15:
                    message.rankingData = reader.bytes();
                    break;
                case 16:
                    message.attachmentImpression = unlockable_attachment_impression_1.UnlockableAttachmentImpression.decode(reader, reader.uint32());
                    break;
                case 17:
                    message.encGeoData = reader.bytes();
                    break;
                case 18:
                    message.withAttachmentOpen = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 19:
                    message.attachmentType = reader.int32();
                    break;
                case 20:
                    message.snapSendRecipientCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 21:
                    message.snapSendCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 22:
                    message.storyPostCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 23:
                    message.memoriesSaveCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 24:
                    message.captureTimeMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 25:
                    message.postCaptureTimeMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 26:
                    message.maxSwipeTimeMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 27:
                    message.maxContinuousTimeMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 28:
                    message.totalTimeMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 29:
                    message.reactionTimestamp = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 30:
                    message.shareTimestamp = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 31:
                    message.swipeUpTimestamp = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 32:
                    message.saveTimestamp = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 33:
                    message.screenshotTimestamp = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 34:
                    message.unlockType = reader.int32();
                    break;
                case 35:
                    message.lensCreativeId = reader.bytes();
                    break;
                case 36:
                    message.firstFaceRenderTimestamp = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 37:
                    message.firstTriggerTimestamp = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 38:
                    message.lensPerformanceMetrics = lens_performance_metrics_1.LensPerformanceMetrics.decode(reader, reader.uint32());
                    break;
                case 39:
                    message.adFlagData = ad_flag_data_1.AdFlagData.decode(reader, reader.uint32());
                    break;
                case 40:
                    message.lensProductImpressionCollectionTrack =
                        lens_product_impression_track_1.LensProductImpressionCollectionTrack.decode(reader, reader.uint32());
                    break;
                case 41:
                    message.lensSource = reader.int32();
                    break;
                case 42:
                    message.stackedImpressions.push(exports.LensStackImpressionTrack.decode(reader, reader.uint32()));
                    break;
                case 43:
                    message.isCachedBeforeSession = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 44:
                    message.isCachedAfterSession = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 45:
                    message.noFillServeItemId = reader.bytes();
                    break;
                case 46:
                    message.snapTakenCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 47:
                    message.infoClickedCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 48:
                    message.withMediaPlayPrecapture = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 49:
                    message.withMediaPlayPostcapture = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 50:
                    message.isRendered = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 51:
                    message.mixerRequestId = reader.bytes();
                    break;
                case 52:
                    message.lensNamespace = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 53:
                    message.sponsoredType = reader.int32();
                    break;
                case 54:
                    message.lensSessionId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 55:
                    message.deviceInfo = device_info_1.DeviceInfo.decode(reader, reader.uint32());
                    break;
                case 56:
                    message.cameraType = reader.int32();
                    break;
                case 57:
                    message.isTrackLoggedIndependently = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 58:
                    message.trackType = reader.int32();
                    break;
                case 59:
                    message.clientTrackLoggingStrategy = reader.int32();
                    break;
                case 60:
                    message.carouselExitEvent = reader.int32();
                    break;
                case 61:
                    message.independentLensImpressionTrigger = reader.int32();
                    break;
                case 62:
                    message.maxScreenPortionRendered = wrappers_1.FloatValue.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLensImpressionTrack();
        message.lensId = object.lensId ?? undefined;
        message.totalSwipedViewMillis = object.totalSwipedViewMillis ?? undefined;
        message.lensOptionId = object.lensOptionId ?? undefined;
        message.swipedOverCount = object.swipedOverCount ?? undefined;
        message.withSnapSend = object.withSnapSend ?? undefined;
        message.withStoryPost = object.withStoryPost ?? undefined;
        message.withMemoriesSave = object.withMemoriesSave ?? undefined;
        message.withSelfieCamera = object.withSelfieCamera ?? undefined;
        message.withWorldCamera = object.withWorldCamera ?? undefined;
        message.isAudioOn = object.isAudioOn ?? undefined;
        message.lensIndexPos = object.lensIndexPos ?? undefined;
        message.encryptedAdTrackData =
            object.encryptedAdTrackData ?? new Uint8Array();
        message.encryptedSponsoredUnlockableTargetingInfoData =
            object.encryptedSponsoredUnlockableTargetingInfoData ?? new Uint8Array();
        message.rankingId = object.rankingId ?? new Uint8Array();
        message.rankingData = object.rankingData ?? new Uint8Array();
        message.attachmentImpression =
            object.attachmentImpression !== undefined &&
                object.attachmentImpression !== null
                ? unlockable_attachment_impression_1.UnlockableAttachmentImpression.fromPartial(object.attachmentImpression)
                : undefined;
        message.encGeoData = object.encGeoData ?? new Uint8Array();
        message.withAttachmentOpen = object.withAttachmentOpen ?? undefined;
        message.attachmentType = object.attachmentType ?? 0;
        message.snapSendRecipientCount = object.snapSendRecipientCount ?? undefined;
        message.snapSendCount = object.snapSendCount ?? undefined;
        message.storyPostCount = object.storyPostCount ?? undefined;
        message.memoriesSaveCount = object.memoriesSaveCount ?? undefined;
        message.captureTimeMillis = object.captureTimeMillis ?? undefined;
        message.postCaptureTimeMillis = object.postCaptureTimeMillis ?? undefined;
        message.maxSwipeTimeMillis = object.maxSwipeTimeMillis ?? undefined;
        message.maxContinuousTimeMillis =
            object.maxContinuousTimeMillis ?? undefined;
        message.totalTimeMillis = object.totalTimeMillis ?? undefined;
        message.reactionTimestamp = object.reactionTimestamp ?? undefined;
        message.shareTimestamp = object.shareTimestamp ?? undefined;
        message.swipeUpTimestamp = object.swipeUpTimestamp ?? undefined;
        message.saveTimestamp = object.saveTimestamp ?? undefined;
        message.screenshotTimestamp = object.screenshotTimestamp ?? undefined;
        message.unlockType = object.unlockType ?? 0;
        message.lensCreativeId = object.lensCreativeId ?? new Uint8Array();
        message.firstFaceRenderTimestamp =
            object.firstFaceRenderTimestamp ?? undefined;
        message.firstTriggerTimestamp = object.firstTriggerTimestamp ?? undefined;
        message.lensPerformanceMetrics =
            object.lensPerformanceMetrics !== undefined &&
                object.lensPerformanceMetrics !== null
                ? lens_performance_metrics_1.LensPerformanceMetrics.fromPartial(object.lensPerformanceMetrics)
                : undefined;
        message.adFlagData =
            object.adFlagData !== undefined && object.adFlagData !== null
                ? ad_flag_data_1.AdFlagData.fromPartial(object.adFlagData)
                : undefined;
        message.lensProductImpressionCollectionTrack =
            object.lensProductImpressionCollectionTrack !== undefined &&
                object.lensProductImpressionCollectionTrack !== null
                ? lens_product_impression_track_1.LensProductImpressionCollectionTrack.fromPartial(object.lensProductImpressionCollectionTrack)
                : undefined;
        message.lensSource = object.lensSource ?? 0;
        message.stackedImpressions =
            object.stackedImpressions?.map((e) => exports.LensStackImpressionTrack.fromPartial(e)) || [];
        message.isCachedBeforeSession = object.isCachedBeforeSession ?? undefined;
        message.isCachedAfterSession = object.isCachedAfterSession ?? undefined;
        message.noFillServeItemId = object.noFillServeItemId ?? new Uint8Array();
        message.snapTakenCount = object.snapTakenCount ?? undefined;
        message.infoClickedCount = object.infoClickedCount ?? undefined;
        message.withMediaPlayPrecapture =
            object.withMediaPlayPrecapture ?? undefined;
        message.withMediaPlayPostcapture =
            object.withMediaPlayPostcapture ?? undefined;
        message.isRendered = object.isRendered ?? undefined;
        message.mixerRequestId = object.mixerRequestId ?? new Uint8Array();
        message.lensNamespace = object.lensNamespace ?? undefined;
        message.sponsoredType = object.sponsoredType ?? 0;
        message.lensSessionId = object.lensSessionId ?? undefined;
        message.deviceInfo =
            object.deviceInfo !== undefined && object.deviceInfo !== null
                ? device_info_1.DeviceInfo.fromPartial(object.deviceInfo)
                : undefined;
        message.cameraType = object.cameraType ?? 0;
        message.isTrackLoggedIndependently =
            object.isTrackLoggedIndependently ?? undefined;
        message.trackType = object.trackType ?? 0;
        message.clientTrackLoggingStrategy = object.clientTrackLoggingStrategy ?? 0;
        message.carouselExitEvent = object.carouselExitEvent ?? 0;
        message.independentLensImpressionTrigger =
            object.independentLensImpressionTrigger ?? 0;
        message.maxScreenPortionRendered =
            object.maxScreenPortionRendered ?? undefined;
        return message;
    },
};
function createBaseLensExplorerImpressionTrack() {
    return { deviceInfo: undefined, lensTileImpressions: [] };
}
exports.LensExplorerImpressionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.deviceInfo !== undefined) {
            device_info_1.DeviceInfo.encode(message.deviceInfo, writer.uint32(10).fork()).ldelim();
        }
        for (const v of message.lensTileImpressions) {
            exports.LensTileImpressionTrack.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLensExplorerImpressionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.deviceInfo = device_info_1.DeviceInfo.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.lensTileImpressions.push(exports.LensTileImpressionTrack.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLensExplorerImpressionTrack();
        message.deviceInfo =
            object.deviceInfo !== undefined && object.deviceInfo !== null
                ? device_info_1.DeviceInfo.fromPartial(object.deviceInfo)
                : undefined;
        message.lensTileImpressions =
            object.lensTileImpressions?.map((e) => exports.LensTileImpressionTrack.fromPartial(e)) || [];
        return message;
    },
};
function createBaseLensTileImpressionTrack() {
    return {
        lensSessionId: undefined,
        lensImpression: undefined,
        tileImpression: undefined,
    };
}
exports.LensTileImpressionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.lensSessionId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.lensSessionId }, writer.uint32(10).fork()).ldelim();
        }
        if (message.lensImpression !== undefined) {
            exports.LensImpressionTrack.encode(message.lensImpression, writer.uint32(18).fork()).ldelim();
        }
        if (message.tileImpression !== undefined) {
            exports.TileViewImpressionTrack.encode(message.tileImpression, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLensTileImpressionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.lensSessionId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.lensImpression = exports.LensImpressionTrack.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.tileImpression = exports.TileViewImpressionTrack.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLensTileImpressionTrack();
        message.lensSessionId = object.lensSessionId ?? undefined;
        message.lensImpression =
            object.lensImpression !== undefined && object.lensImpression !== null
                ? exports.LensImpressionTrack.fromPartial(object.lensImpression)
                : undefined;
        message.tileImpression =
            object.tileImpression !== undefined && object.tileImpression !== null
                ? exports.TileViewImpressionTrack.fromPartial(object.tileImpression)
                : undefined;
        return message;
    },
};
function createBaseTileViewImpressionTrack() {
    return {
        lensId: undefined,
        encryptedAdTrackData: new Uint8Array(),
        encryptedSponsoredUnlockableTargetingInfoData: new Uint8Array(),
        rankingId: new Uint8Array(),
        rankingData: new Uint8Array(),
        encGeoData: new Uint8Array(),
        lensCreativeId: new Uint8Array(),
        adFlagData: undefined,
        tileTimeMillis: undefined,
        tileTapped: undefined,
        launchedSelfie: undefined,
        tileIndexPos: undefined,
        tileMaxViewedPercentage: undefined,
    };
}
exports.TileViewImpressionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.lensId !== undefined) {
            wrappers_1.StringValue.encode({ value: message.lensId }, writer.uint32(10).fork()).ldelim();
        }
        if (message.encryptedAdTrackData.length !== 0) {
            writer.uint32(18).bytes(message.encryptedAdTrackData);
        }
        if (message.encryptedSponsoredUnlockableTargetingInfoData.length !== 0) {
            writer
                .uint32(26)
                .bytes(message.encryptedSponsoredUnlockableTargetingInfoData);
        }
        if (message.rankingId.length !== 0) {
            writer.uint32(34).bytes(message.rankingId);
        }
        if (message.rankingData.length !== 0) {
            writer.uint32(42).bytes(message.rankingData);
        }
        if (message.encGeoData.length !== 0) {
            writer.uint32(50).bytes(message.encGeoData);
        }
        if (message.lensCreativeId.length !== 0) {
            writer.uint32(58).bytes(message.lensCreativeId);
        }
        if (message.adFlagData !== undefined) {
            ad_flag_data_1.AdFlagData.encode(message.adFlagData, writer.uint32(66).fork()).ldelim();
        }
        if (message.tileTimeMillis !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.tileTimeMillis }, writer.uint32(74).fork()).ldelim();
        }
        if (message.tileTapped !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.tileTapped }, writer.uint32(82).fork()).ldelim();
        }
        if (message.launchedSelfie !== undefined) {
            wrappers_1.BoolValue.encode({ value: message.launchedSelfie }, writer.uint32(90).fork()).ldelim();
        }
        if (message.tileIndexPos !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.tileIndexPos }, writer.uint32(98).fork()).ldelim();
        }
        if (message.tileMaxViewedPercentage !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.tileMaxViewedPercentage }, writer.uint32(106).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseTileViewImpressionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.lensId = wrappers_1.StringValue.decode(reader, reader.uint32()).value;
                    break;
                case 2:
                    message.encryptedAdTrackData = reader.bytes();
                    break;
                case 3:
                    message.encryptedSponsoredUnlockableTargetingInfoData =
                        reader.bytes();
                    break;
                case 4:
                    message.rankingId = reader.bytes();
                    break;
                case 5:
                    message.rankingData = reader.bytes();
                    break;
                case 6:
                    message.encGeoData = reader.bytes();
                    break;
                case 7:
                    message.lensCreativeId = reader.bytes();
                    break;
                case 8:
                    message.adFlagData = ad_flag_data_1.AdFlagData.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.tileTimeMillis = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 10:
                    message.tileTapped = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 11:
                    message.launchedSelfie = wrappers_1.BoolValue.decode(reader, reader.uint32()).value;
                    break;
                case 12:
                    message.tileIndexPos = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 13:
                    message.tileMaxViewedPercentage = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseTileViewImpressionTrack();
        message.lensId = object.lensId ?? undefined;
        message.encryptedAdTrackData =
            object.encryptedAdTrackData ?? new Uint8Array();
        message.encryptedSponsoredUnlockableTargetingInfoData =
            object.encryptedSponsoredUnlockableTargetingInfoData ?? new Uint8Array();
        message.rankingId = object.rankingId ?? new Uint8Array();
        message.rankingData = object.rankingData ?? new Uint8Array();
        message.encGeoData = object.encGeoData ?? new Uint8Array();
        message.lensCreativeId = object.lensCreativeId ?? new Uint8Array();
        message.adFlagData =
            object.adFlagData !== undefined && object.adFlagData !== null
                ? ad_flag_data_1.AdFlagData.fromPartial(object.adFlagData)
                : undefined;
        message.tileTimeMillis = object.tileTimeMillis ?? undefined;
        message.tileTapped = object.tileTapped ?? undefined;
        message.launchedSelfie = object.launchedSelfie ?? undefined;
        message.tileIndexPos = object.tileIndexPos ?? undefined;
        message.tileMaxViewedPercentage =
            object.tileMaxViewedPercentage ?? undefined;
        return message;
    },
};
function createBaseLensStackImpressionTrack() {
    return {
        appliedLensIds: [],
        snapSendCount: undefined,
        storyPostCount: undefined,
        memoriesSaveCount: undefined,
    };
}
exports.LensStackImpressionTrack = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.appliedLensIds) {
            wrappers_1.StringValue.encode({ value: v }, writer.uint32(10).fork()).ldelim();
        }
        if (message.snapSendCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.snapSendCount }, writer.uint32(18).fork()).ldelim();
        }
        if (message.storyPostCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.storyPostCount }, writer.uint32(26).fork()).ldelim();
        }
        if (message.memoriesSaveCount !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.memoriesSaveCount }, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLensStackImpressionTrack();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.appliedLensIds.push(wrappers_1.StringValue.decode(reader, reader.uint32()).value);
                    break;
                case 2:
                    message.snapSendCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 3:
                    message.storyPostCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 4:
                    message.memoriesSaveCount = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLensStackImpressionTrack();
        message.appliedLensIds = object.appliedLensIds?.map((e) => e) || [];
        message.snapSendCount = object.snapSendCount ?? undefined;
        message.storyPostCount = object.storyPostCount ?? undefined;
        message.memoriesSaveCount = object.memoriesSaveCount ?? undefined;
        return message;
    },
};
//# sourceMappingURL=lens_impression_track.js.map